import { render, staticRenderFns } from "./document-category-select-item.vue?vue&type=template&id=6cc48298&lang=pug&"
import script from "./document-category-select-item.vue?vue&type=script&lang=ts&"
export * from "./document-category-select-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports